import { Text } from "@/components/ui";
import {
  TREE_ICON_CLASS,
  TREE_ROW_CLASS,
  TREE_TEXT_CLASS,
} from "@/components/features/matter/file-repo/FolderTree";
import { cn } from "@/lib/utils/cn";
import { ChevronRight, FolderKanban } from "lucide-react";
import type { ReactNode } from "react";

export function MassTortMattersFolder({
  expanded,
  selected,
  onSelect,
  children,
}: {
  expanded: boolean;
  selected: boolean;
  onSelect: () => void;
  children: ReactNode;
}) {
  return (
    <div className="px-2">
      <button
        type="button"
        aria-expanded={expanded}
        onClick={onSelect}
        className={cn(
          TREE_ROW_CLASS,
          "w-full cursor-pointer text-left",
          selected && "bg-primary/10 text-primary hover:bg-primary/20",
        )}
        style={{ paddingLeft: "20px" }}
        title="Matters"
      >
        <ChevronRight
          className={cn(
            "mr-1 transition-transform",
            TREE_ICON_CLASS,
            expanded && "rotate-90",
          )}
        />
        <FolderKanban className={cn("mr-2 text-sky-400", TREE_ICON_CLASS)} />
        <Text
          variant="subHeading"
          color="foreground"
          as="span"
          className={TREE_TEXT_CLASS}
        >
          Matters
        </Text>
      </button>
      {expanded ? <div className="pl-5">{children}</div> : null}
    </div>
  );
}
